// extracted by mini-css-extract-plugin
export default {"EventDetails":"styles_EventDetails__6O3LW"};